// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isEngagementLandingPagesAppGroupIdLandingPageIdCopyTargetAppGroupIdResult = objectOf({
  landing_page_bson_id: string,
  app_group_id: string,
  source_landing_page_bson_id: string,
  source_app_group_id: string,
});
